import { createAsyncThunk } from '@reduxjs/toolkit'
import Thumbnail from './thumbnail-model'
import {
  delete_thumbnail,
  load_thumbnails,
  store_thumbnail,
} from './thumbnail-service'

export const LoadThumbnailsAsync = createAsyncThunk<any, any>(
  'composer/load/thumbnail',
  async (params: { uid: string }) => {
    return await load_thumbnails(params)
  },
)

export const CreateThumbnailAsync = createAsyncThunk<any, any>(
  'composer/create/thumbnail',
  async (params: Thumbnail) => {
    return await store_thumbnail(params)
  },
)

export const DeleteThumbnailAsync = createAsyncThunk<any, any>(
  'composer/delete/thumbnail',
  async (params) => {
    return await delete_thumbnail(params)
  },
)
